import { MatchKeyType } from "../types/matchSetState";

export { MatchKeyType };

export interface CandidateMatchKey {
  key: string;
  type: MatchKeyType;
}

interface AttrValue {
  stringValue?: string;
}

interface RecordLike {
  clientAttributes?: Record<string, AttrValue>;
  content?: { clientAttributes?: Record<string, AttrValue> };
}

interface CbeLike {
  idempotenceId: string;
  records: Record<string, RecordLike> | RecordLike[];
}

const RCSL_KEY = "rcsl_entry_source_id";
const INVOICE_KEY = "digital_invoice_pipeline_source_unique_id";
const DEFERRAL_KEY = "deferral_id";

function getClientAttrs(r: RecordLike): Record<string, AttrValue> | undefined {
  return r.clientAttributes ?? r.content?.clientAttributes;
}

export function extractMatchKeyFromRecord(r: RecordLike): string | undefined {
  const attrs = getClientAttrs(r);
  return attrs?.[RCSL_KEY]?.stringValue ?? attrs?.[INVOICE_KEY]?.stringValue;
}

export function extractCandidateMatchKeys(
  cbes: CbeLike[]
): CandidateMatchKey[] {
  const seen = new Set<string>();
  const candidates: CandidateMatchKey[] = [];

  const addCandidate = (key: string | undefined, type: MatchKeyType) => {
    if (key && !seen.has(key)) {
      seen.add(key);
      candidates.push({ key, type });
    }
  };

  cbes
    .filter((cbe) => !cbe.idempotenceId.includes("NONE"))
    .forEach((cbe) => {
      const records = cbe.records || {};
      const list: RecordLike[] = Array.isArray(records)
        ? records
        : Object.values(records);

      list.forEach((r) => {
        const attrs = getClientAttrs(r);
        addCandidate(attrs?.[RCSL_KEY]?.stringValue, MatchKeyType.REVENUE);
        addCandidate(attrs?.[INVOICE_KEY]?.stringValue, MatchKeyType.ROYALTY);
        addCandidate(attrs?.[DEFERRAL_KEY]?.stringValue, MatchKeyType.DEFERRAL);
      });
    });

  return candidates;
}

export function extractMatchKeysFromCbes(cbes: CbeLike[]): string[] {
  return extractCandidateMatchKeys(cbes).map((c) => c.key);
}
